import { getFiGrowthBook } from '../lib/growthbook';
import useHardwareFirstCheckout from './useHardwareFirstCheckout';

/**
 * Whether the free trial is on offer for this visitor, from the 'free-trial-enabled' feature.
 * Always false for the hardware-first arm, which does not offer a trial.
 *
 * This is the flag-level gate only. Per-visitor eligibility (trial already in cart, previously
 * purchased, existing membership) lives in useFreeTrialEligibility.
 */
export default function useFreeTrialEnabled(): boolean {
  const isHardwareFirstEnrolled = useHardwareFirstCheckout();
  return !isHardwareFirstEnrolled && getFiGrowthBook().getFeatureValue<boolean>('free-trial-enabled', false);
}
